import { render, staticRenderFns } from "./SkillsUpdate.vue?vue&type=template&id=4dcef986&"
import script from "./SkillsUpdate.vue?vue&type=script&lang=js&"
export * from "./SkillsUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports